export const base_url = process.env.REACT_APP_API_DATA_BASEURL;

const api = {
    // organizations
    POST_LOGIN: base_url + "customer/login",
    GET_LABELS: base_url + "label/getlabel",
    GET_PRODUCTS: base_url + "product/getproduct",
    GET_PRODUCTS_EXPORT: base_url + "product/getexportproducts",
    DOWNLOAD_RELEASE: base_url + "product/downloadassets",
    GET_HOMEPAGE_PRODUCTS: base_url + "product/gethomepageproducts",
    CHANGE_PASSWORD: base_url + "customer/changepassword",
    FORGOT_PASSWORD: base_url + "customer/forgotpasswordotp",
    GET_FORMATS: base_url + "formats/getformats",
    GET_GENERIC: base_url + "genre/getgenre",
    GET_CUSTOMER: base_url + "customer/getcustomer",
    PUT_CUSTOMER: base_url + "customer/updatecustomer",
    GET_CUSTOMER_ORDER: base_url + "cartitems/getcartitems",
    ADD_TO_CART_ORDERS: base_url + "cartitems/postcartitems",
    CART_DATA_SHOW: base_url + "cartitems/getcartitems",
    DELETE_CART: base_url + "cartitems/deletecartitems",
    CART_INFO: base_url + "cartitems/updatecartitems",
    ORDER_INFO: base_url + "cartitems/excelcartitems",
    // ORDER_INFO: base_url + "orders/postorder",
    GET_BANNER: base_url + "banner/getbanner",
    RELEASES_FILTER: base_url + "product/getproduct",
    GET_ORDERS: base_url + "orders/getorder",
    GET_SEARCH_PRODUCT: base_url + "product/getsearchproduct",
    GET_SECONDRY_IMAGES: base_url + "product/getsecondaryimage",
    GET_PRODUCT_TRACKS: base_url + "product/getproducttracks",
    RESET_PASSWORD: base_url + "customer/forgotpassword"
}
export default api;